import "./Badges.scss";

import type { BadgesProps } from ".";
import { BadgesPtu } from "./BadgesPtu";
import { BadgesRegular } from "./BadgesRegular";
import { BadgesStripe } from "./BadgesStripe";

const BadgesController: React.FC<BadgesProps> = ({ data }) => {
  const { type, provider } = data;

  if (provider === "stripe") {
    return <BadgesStripe data={data} />;
  }

  return type === "Regular" ? (
    <BadgesRegular data={data} />
  ) : (
    <BadgesPtu data={data} />
  );
};

export { BadgesController };
